
export { QuantitySelect } from './QuantitySelect'

import React, { useState, useEffect, useRef } from 'react'
import { Pane, Tablist, Tab, Paragraph, ListIcon, ComparisonIcon, Heading, Spinner } from 'evergreen-ui'
import { MaterialTable } from './MaterialTable'
import { QuantitySelect } from './QuantitySelect'
import { TypeList } from './TypeList'

import { Money, ContactUs, EmailLink, PhoneLink } from '../../Misc'
import img from '../../assets/transparent_favicon.png';


export function SelectMaterials(props) {
  const tabs = [`By Categories`, 'By List'];
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  
  if (!props.Materials)
    return <Pane display="flex" alignItems="center" justifyContent="center" height={400}>
       <img src={img} className={"rotate"} width={"100px"} />
    </Pane>

  return <Pane width={"90%"}>
    {/* <QuantitySelect display={"flex"} order={props.order} setOrder={props.setOrder} caption={'Quantity'} /> */}

    {0 === selectedIndex && <Pane
      key={tabs[0]}
      id={`panel-${tabs[0]}`}
      role="tabpanel"
      aria-labelledby={tabs[0]}
      aria-hidden={0 !== selectedIndex}
    >
      <TypeList
        onSelectMaterial={props.setMaterial}
        Materials={props.Materials}
        selMaterial={props.material}
      ></TypeList>
    </Pane>}

    {1 === selectedIndex && <Pane
      key={tabs[1]}
      id={`panel-${tabs[1]}`}
      role="tabpanel"
      aria-labelledby={tabs[1]}
      aria-hidden={1 !== selectedIndex}
    >

      <MaterialTable
        showHeadings={1}
        selMaterial={props.material} onSelectMaterial={props.setMaterial}
        Materials={props.Materials}></MaterialTable>

    </Pane>}

    <Pane display="flex" padding={8} marginBottom={16} borderRadius={3}
      style={{ display: 'Flex', alignContent: 'center', alignItems: 'center' }}>
      <Pane flex={1} marginRight={16} display="flex" >

        <Tablist marginBottom={16} flexBasis={240} marginRight={24}>
          <Tab
            key={tabs[0]}
            id={tabs[0]}
            onSelect={() => setSelectedIndex(0)}
            isSelected={0 === selectedIndex}
            aria-controls={`panel-${tabs[0]}`}
          >
            <ComparisonIcon marginRight={5} /> {tabs[0]}
          </Tab>

          <Tab
            key={tabs[1]}
            id={tabs[1]}
            onSelect={() => setSelectedIndex(1)}
            isSelected={1 === selectedIndex}
            aria-controls={`panel-${tabs[1]}`}
          >
            <ListIcon marginRight={5} /> {tabs[1]}
          </Tab>
        </Tablist>
      </Pane>
    </Pane>

    <Pane flex={1} alignItems="center" textAlign="center" justifyContent="center" margin={8}>
      <Heading fontSize={"15px"}>If the material that you need isn’t displayed,
        get <ContactUs>in contact</ContactUs> with our friendly team today.</Heading>
      <p><EmailLink subject="[DuraProducts] Material Request">sales@duraproducts.com.au</EmailLink> or call <PhoneLink>02 6361 9008</PhoneLink></p>
    </Pane>
  </Pane>

}

